import { render, staticRenderFns } from "./AddRequest.vue?vue&type=template&id=186b9467"
import script from "./AddRequest.vue?vue&type=script&lang=js"
export * from "./AddRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports